type AuthDividerProps = {
  label?: string;
};

export default function AuthDivider({ label = "or" }: AuthDividerProps) {
  return (
    <div className="relative">
      <div className="absolute inset-0 flex items-center">
        <div className="w-full border-t border-gray-300" />
      </div>
      <div className="relative flex justify-center text-sm">
        <span className="bg-gray-25 px-4 font-medium text-gray-500">{label}</span>
      </div>
    </div>
  );
}
